import { Wrapper } from '@ahmdigital/ui';
import classnames from 'classnames';
import React, { ReactNode } from 'react';

import styles from './styles.module.sass';

type LegacyBorderedWrapperProps = {
  children: ReactNode;
  className?: string;
};

// @ts-expect-error - Automatic, Please fix when editing this file
const LegacyBorderedWrapper = ({ children, className = null }: LegacyBorderedWrapperProps) => (
  <Wrapper size="extraExtraLarge" isFullWidth className={classnames(styles.withBorders, className)}>
    {children}
  </Wrapper>
);

export default LegacyBorderedWrapper;
